import React, { useState } from 'react';
import { Card, Text } from 'v3/components';
import { Row, Col } from 'react-bootstrap';
import { DetailsWrapper } from './styles';
import { formatTimeSpecifier } from 'v3/utils/formatter';
import {
  FaMapMarkerAlt,
} from 'react-icons/fa';

export function TollsPlaza({ tollsPlazaInfos, tollsPlazaLoading, takerValue }) {
  const [showDetails, setShowDetails] = useState(true);
  const realKmValue =
    takerValue > 0 && tollsPlazaInfos?.totalKm > 0
      ? (takerValue / tollsPlazaInfos.totalKm).toFixed(2)
      : null;
  const emptyMessage =
    tollsPlazaInfos?.calculationMessage ||
    (tollsPlazaInfos?.requestError
      ? 'Não foi possível calcular o pedágio da rota selecionada.'
      : 'A rota selecionada não possui pedágios.');

  return (
    <>
      {
        tollsPlazaInfos?.tollsPlaza.length > 0 ? (
          <Card
            loading={tollsPlazaLoading}
            header={
              <div className='d-flex'>
                <Row>
                  <Col style={{ display: 'flex', gap: '1rem' }}>
                    <Text weight={300} fontSize={14}>
                      Pedágio calculado: <Text weight={700}>{`R$ ${tollsPlazaInfos?.totalTollValue.toFixed(2) || 0}`}</Text>
                    </Text>

                    <Text weight={300} fontSize={14}>
                      Praças: <Text weight={700}>{tollsPlazaInfos?.tollsPlaza?.length || 0}</Text>
                    </Text>

                    <Text weight={300} fontSize={14}>
                      Eixos: <Text weight={700}>{tollsPlazaInfos?.totalAxes || 0}</Text>
                    </Text>

                    <Text weight={300} fontSize={14}>
                      Tempo/Distância: <Text weight={700}>{formatTimeSpecifier(tollsPlazaInfos?.expectedTime)}</Text> / <Text weight={700}>{tollsPlazaInfos?.totalKm}km</Text>
                    </Text>
                    {realKmValue !== null && (
                      <Text weight={300} fontSize={14}>
                        Real Km: <Text weight={700}>R$ {realKmValue}</Text>
                      </Text>
                    )}
                  </Col>
                </Row>
              </div>
            }
            HeaderRightComponent={
              <Text type="label" clickable={true} onClick={() => setShowDetails(prev => !prev)}>
                {showDetails ? '▼ Ocultar Detalhes' : '▶ Mostrar Detalhes'}
              </Text>
            }
          >
            <DetailsWrapper show={showDetails}>
              {tollsPlazaInfos?.tollsPlaza?.map((toll, index) => (
                <Row key={index} style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                  <Col md={4} xs={4}>
                    <Text weight={300} fontSize={14}>
                      {index + 1} - {toll.name}
                    </Text>
                  </Col>
                  <Col md={7} xs={7}>
                    <FaMapMarkerAlt />
                    <Text weight={300} fontSize={14}>
                      {toll.address}
                    </Text>
                  </Col>
                  <Col md={1} xs={1}>
                    <Text weight={300} fontSize={14}>
                      R$: {toll.tollValue.toFixed(2)}
                    </Text>
                  </Col>
                </Row>
              ))}
            </DetailsWrapper>
          </Card>

        ) : (
          <>
            <Card
              loading={tollsPlazaLoading}
              header={
                <Text weight={16} fontSize={16}>
                  {emptyMessage}
                </Text>
              }
            >
            </Card>
          </>
        )
      }
    </>
  )
}
